// extracted by mini-css-extract-plugin
export default {"boxOffice":"boxOffice_boxOffice__SEhdh","titleWrap":"boxOffice_titleWrap__B+Nuc","title":"boxOffice_title__WHAVX","subTitle":"boxOffice_subTitle__cBDOA"};